module.exports = __webpack_public_path__ + "static/img/app.17983b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/app.png
// module id = Bsou
// module chunks = 0